import { Hotspot } from "@/ui";
import type { Callout } from "./gscData";

/** Props every tab receives so its pins can drive the shared ExplainerPanel. */
export interface TabCalloutProps {
  openId: string | null;
  visited: ReadonlySet<string>;
  onOpen: (c: Callout) => void;
}

interface CalloutPinProps extends TabCalloutProps {
  callout: Callout;
  /** Absolute positioning classes — Hotspot must be absolutely positioned. */
  className: string;
}

export function CalloutPin({ callout, className, openId, visited, onOpen }: CalloutPinProps) {
  const selected = openId === callout.id;
  return (
    <Hotspot
      n={callout.n}
      selected={selected}
      visited={!selected && visited.has(callout.id)}
      onClick={() => onOpen(callout)}
      className={className}
      label={callout.title}
    />
  );
}
